import { JSX, useContext } from "react";

import { RoleRestricted, Roles } from "@app/user";
import MegaMenuHeader from "./MegaMenuHeader";

import MenuItemEnum from "@app/layout/menus/menuItemEnum";

import MegaMenuLink from "./MegaMenuLink";
import { Features } from "../../feature-flags";
import { FeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";
//NOTE: Once a page is moved from 1.0 to 2.0, the MegaMenuStandardLink should be replaced with MegaMenuLink to prevent an unnecessary re-rendering of the whole page
export default function ManageMenu(): JSX.Element {
  const featureFlags = useContext(FeatureFlagContext).enabledFeatureFlags;

  return (
    <ul className="menu">
      <li>
        <MegaMenuHeader title="Manage" />
        <ul className="menu">
          <RoleRestricted allowedRoles={[Roles.VOLUME_TERMINATOR]}>
            <RoleRestricted allowedRoles={[Roles.TERM_PROVIDER_ADMIN]}>
              <MegaMenuLink menuItem={MenuItemEnum.Termination} faIcon="user-times" to="/terminations/view" linkText="Termination" />
            </RoleRestricted>
          </RoleRestricted>
          <RoleRestricted allowedRoles={[Roles.VOLUME_TARGET]}>
            <MegaMenuLink menuItem={MenuItemEnum.Targeting} faIcon="bullseye" to="/targeting/view" linkText="Targeting" />
          </RoleRestricted>
          <RoleRestricted allowedRoles={[Roles.QUEST_USER, Roles.CLIENT_ADMIN]}>
            <MegaMenuLink menuItem={MenuItemEnum.EditProjects} faIcon="pencil-square-o" to="/projects/edit" linkText="Edit Projects" />
          </RoleRestricted>
          <RoleRestricted allowedRoles={[Roles.CLIENT_ADMIN]}>
            <MegaMenuLink menuItem={MenuItemEnum.ManageTags} faIcon="tags" to="/tags/view" linkText="Tags" />
          </RoleRestricted>
          {featureFlags.has(Features.VOLUME_EXCEPTIONS) &&
            <RoleRestricted allowedRoles={[Roles.EXCEPTION_MANAGER]}>
              <MegaMenuLink menuItem={MenuItemEnum.Exceptions} faIcon="flag" to="/exceptions/view" linkText="Exceptions" />
            </RoleRestricted>
          }
          {featureFlags.has(Features.ADEQUACY_REPORT_CUSTOMIZATION) && (
            <MegaMenuLink menuItem={MenuItemEnum.ReportPresets} faIcon="download" to="/report-presets" linkText="Report Presets" />
          )}
        </ul>
      </li>
    </ul>
  );
}
